import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=49c5bb1c&"
import script from "./PricingDetails.vue?vue&type=script&lang=js&"
export * from "./PricingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports